var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/shield"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shield"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.00005 17.0701C8.18255 17.0701 7.37255 16.8301 6.73505 16.3576L3.51005 13.9501C2.65505 13.3126 1.98755 11.9776 1.98755 10.9201V5.34008C1.98755 4.18508 2.83505 2.95508 3.92255 2.55008L7.66505 1.14758C8.40755 0.870078 9.57755 0.870078 10.32 1.14758L14.0625 2.55008C15.15 2.95508 15.9975 4.18508 15.9975 5.34008V10.9126C15.9975 11.9776 15.33 13.3051 14.475 13.9426L11.25 16.3501C10.6275 16.8301 9.81755 17.0701 9.00005 17.0701ZM8.06255 2.20508L4.32005 3.60758C3.68255 3.84758 3.12005 4.65758 3.12005 5.34758V10.9201C3.12005 11.6326 3.62255 12.6301 4.18505 13.0501L7.41005 15.4576C8.27255 16.1026 9.72755 16.1026 10.5975 15.4576L13.8225 13.0501C14.3925 12.6226 14.8875 11.6326 14.8875 10.9201V5.34008C14.8875 4.65758 14.325 3.84758 13.6875 3.60008L9.94505 2.19758C9.43505 2.01758 8.56505 2.01758 8.06255 2.20508Z",
    fill: "#F73B58"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.533a166e6289b1fccecc1a7981c06a1e.svg";
export { ForwardRef as ReactComponent };